import { useCallback, useState } from 'react';

const EMAIL_LINK_CLASS =
    'text-white underline decoration-white/25 underline-offset-4 transition-colors hover:decoration-white/60';

/** Assemble only in the browser so HTML scrapers do not see a raw address. */
function contactAddress(): string {
    const local = 'swenoleksa'.split('').reverse().join('');
    const host = 'moc.liamg'.split('').reverse().join('');
    return `${local}@${host}`;
}

export function ObfuscatedContactEmail() {
    const [address, setAddress] = useState<string | null>(null);

    const reveal = useCallback(() => {
        setAddress((current) => current ?? contactAddress());
    }, []);

    return (
        <a
            href={address ? `mailto:${address}` : '#contact-email'}
            className={EMAIL_LINK_CLASS}
            dir="ltr"
            lang="en"
            aria-label={address ?? 'כתובת אימייל ליצירת קשר'}
            onFocus={reveal}
            onMouseEnter={reveal}
            onTouchStart={reveal}
            onClick={(event) => {
                const next = address ?? contactAddress();
                if (!address) {
                    setAddress(next);
                    event.preventDefault();
                    window.location.href = `mailto:${next}`;
                }
            }}
        >
            {address ? (
                address
            ) : (
                <span
                    aria-hidden
                    className="inline-block"
                    style={{ unicodeBidi: 'bidi-override', direction: 'rtl' }}
                >
                    moc.liamg@swenoleksa
                </span>
            )}
        </a>
    );
}
